<template>
  <div class="container-alter">
    <p class="result">
      字数：{{ result.numberOfWords }}
      <br />
      电费：{{ result.money }}
    </p>
    <p class="process">
      {{ result.currentTableNumber }} - {{ result.lastTableNumber }} =
      {{ result.numberOfWords }}(字) * {{ result.unitPrice }} =
      {{ result.money }}
    </p>
    <p class="waring">
      确认数据无误后点击提交记录，如数据有误点击右上角“X”关闭
    </p>
    <el-button type="success" class="confirm" @click="postData">提交记录</el-button>
    <div class="close" @click="close">X</div>
    </div>
</template>

<script>
import * as api from "@/api/api";
import { showMessage } from "@/utils";
export default {
  props: {
    result: Object,
  },
  methods: {
    async postData() {
      try {
        const result = await api.postRecord(this.result);
        showMessage({
          content: result,
          type: "success",
          duration: 2000,
        });
        const lastNumber = await api.getLastTableCount();
        this.$emit("close",lastNumber.currentTableNumber);
      } catch (err) {
        console.log(err);
      }
    },
    close() {
      this.$emit("close");
    },
  },
};
</script>

<style scoped lang="less">
.container-alter {
  width: 90%;
  height: 40%;
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%;-50%);
  background-color: rgb(242, 244, 251);
  border: 1px solid #000;
  box-shadow: -1px -1px #231818;
  .result {
    width: 100%;
    height: 40%;
    padding-top: 20px;
    text-align: center;
    line-height: 50px;
    font-size: 20px;
  }
  .waring {
    color: red;
    padding: 0 20px;
    text-align: center;
    line-height: 25px;
  }
  .process {
    width: 100%;
    text-align: center;
  }
  .confirm {
    width: 100%;
    height: 20%;
    position: absolute;
    bottom: 0px;
    font-size: 20px;
  }
  .close {
    width: 30px;
    height: 30px;
    position: absolute;
    right: 0px;
    top: 0px;
    text-align: center;
    line-height: 30px;
    font-size: 16px;
    // background-color: red;
    color: red;
  }
}
</style>
